module.exports = __webpack_public_path__ + "static/media/icon-configs.b30c6b17.svg";